import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";

import SideBar from "../../../components/SideBar";
import BackButton from "../../../components/Base/BackButton";
import PageHeader from "../../../components/AdminCoachPanel/coaches/PageHeader/PageHeader";
import UserCoachingSection, {
  isSuccess,
  responseMessage,
} from "../../../components/CreditsPanel/UserCoachingSection/UserCoachingSection";
import { getMemberByEmail } from "../../../api/User";
import { Components } from "../../../assets/Dimensions";
import UserLookupCard, {
  LookupMode,
  lookupModeToLoginType,
} from "./components/UserLookupCard";

// Reuse the coaches page wrapper and the profile card/breadcrumb styling.
import "../Coaches.css";
import "../../Coaches/CoachProfilePage.css";
import "./UserCoachings.css";

function parseUserIdParam(search) {
  const raw = new URLSearchParams(search).get("userId");
  return raw && /^\d+$/.test(raw) && Number(raw) > 0 ? Number(raw) : null;
}

// CoachAdmins' way into user coaching management — they can't open the
// Administrators-only Credits page, where the same section is embedded.
export default function UserCoachings() {
  const history = useHistory();
  const location = useLocation();
  const userAdminToken = sessionStorage.getItem("jwtP");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const [nav, setNav] = useState(false);

  // The selected user lives in the URL (?userId=) so reloads keep the page.
  // Only the internal id goes there — never the phone/email.
  const userId = parseUserIdParam(location.search);
  const [lookupLabel, setLookupLabel] = useState("");
  const [lookupLoading, setLookupLoading] = useState(false);

  const selectUser = (id, label) => {
    setLookupLabel(label);
    history.replace({ pathname: location.pathname, search: `?userId=${id}` });
  };

  // Phone/email → UserId, resolved from the user's credit rows (the only lookup
  // the admin API offers today).
  const handleLookup = async (mode, value) => {
    if (mode === LookupMode.UserId) {
      selectUser(Number(value), "");
      return;
    }
    setLookupLoading(true);
    try {
      const res = await getMemberByEmail(
        value,
        lookupModeToLoginType(mode),
        userAdminToken,
        true
      );
      const credits = isSuccess(res) && res.data.ResponseData;
      const withUser = Array.isArray(credits)
        ? credits.find((c) => c.UserId)
        : null;
      if (withUser) {
        const prefix = mode === LookupMode.Email ? "E-posta" : "Telefon";
        selectUser(withUser.UserId, `${prefix}: ${value}`);
      } else if (isSuccess(res)) {
        toast.error(
          "Kullanıcıya ait kredi kaydı bulunamadı. Kullanıcı ID ile arayınız."
        );
      } else {
        toast.error(responseMessage(res, "Kullanıcı bulunamadı."));
      }
    } catch (err) {
      console.error("getMemberByEmail error", err);
      toast.error("Bir hata oluştu, lütfen tekrar deneyiniz.");
    } finally {
      setLookupLoading(false);
    }
  };

  return (
    <>
      {isTabletOrMobile ? (
        <div>
          <span
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={() => setNav(!nav)}
          >
            menu
          </span>
          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}
      <ToastContainer autoClose={5000} />

      <div
        className="coaches-page"
        style={{
          paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,
        }}
      >
        <div className="coaches-page-container">
          <BackButton />

          <div className="coach-profile-breadcrumb">
            <span
              className="breadcrumb-link"
              onClick={() => history.push("/CoachesAdminPanel")}
            >
              Koçlar
            </span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">Kullanıcı Koçluk Yönetimi</span>
          </div>

          <PageHeader title="Kullanıcı Koçluk Yönetimi" />

          <div className="coach-profile-card uc-card">
            <UserLookupCard loading={lookupLoading} onLookup={handleLookup} />
          </div>

          {userId && (
            <div className="coach-profile-card uc-card uc-card-flush">
              <h3 className="uc-card-title">Koçluk Kayıtları</h3>
              <UserCoachingSection userId={userId} userLabel={lookupLabel} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
